// Game catalog (14 total)
const HUB_HERO =
  "https://static.prod-images.emergentagent.com/jobs/1b50bf18-ab86-47e3-8c7b-2dc2af0ac3d3/images/63ce7c5f1ae979814b3b5b2150919ceba83af331be051f93d423abc5d3f48896.png";

export const GAMES = [
  // === Atenção / TDAH ===
  {
    id: "galaxy_defender",
    name: "Defensor da Galáxia",
    short: "Atenção & Inibição",
    description: "Mire nos asteroides azuis e ignore os vermelhos.",
    test: "TOVA / CPT — atenção sustentada",
    color: "#38BDF8",
    emoji: "🚀",
    category: "Atenção & funções executivas",
    bg: "https://static.prod-images.emergentagent.com/jobs/1b50bf18-ab86-47e3-8c7b-2dc2af0ac3d3/images/e83f47d126209855ccdecdba704d0b4903bf41a075965f0f83c60d3972a59fd6.png",
    route: "/play/game/galaxy-defender",
  },
  {
    id: "color_forest",
    name: "Floresta das Cores",
    short: "Controle inibitório",
    description: "Toque na cor que a palavra está pintada, não no que ela diz.",
    test: "Teste de Stroop",
    color: "#A3E635",
    emoji: "🌳",
    category: "Atenção & funções executivas",
    bg: "https://static.prod-images.emergentagent.com/jobs/1b50bf18-ab86-47e3-8c7b-2dc2af0ac3d3/images/4d084464a53487e2a1b77d59e0475e3c277493a36362542edc6bb96f4538637e.png",
    route: "/play/game/color-forest",
  },
  {
    id: "star_path",
    name: "Caminho das Estrelas",
    short: "Flexibilidade mental",
    description: "Ligue as estrelas alternando número e letra: 1, A, 2, B...",
    test: "Trail Making Test",
    color: "#F472B6",
    emoji: "⭐",
    category: "Atenção & funções executivas",
    bg: "https://static.prod-images.emergentagent.com/jobs/1b50bf18-ab86-47e3-8c7b-2dc2af0ac3d3/images/71084476db18ddfae9ced41c3c88b01f5cf2d1bfcf5c149c8696947eefc41574.png",
    route: "/play/game/star-path",
  },
  {
    id: "port_crane",
    name: "Guindaste do Porto",
    short: "Planejamento",
    description: "Mova os contêineres para deixar igual ao modelo.",
    test: "Torre de Londres",
    color: "#0284C7",
    emoji: "🏗️",
    category: "Atenção & funções executivas",
    bg: "https://static.prod-images.emergentagent.com/jobs/1b50bf18-ab86-47e3-8c7b-2dc2af0ac3d3/images/38e28fb6aaa29623bec0f42874e9d16578c1d5538ba19f31efcc0d6af2325915.png",
    route: "/play/game/port-crane",
  },

  // === Inteligência / Cognição Geral ===
  {
    id: "builders_workshop",
    name: "Oficina do Construtor",
    short: "Raciocínio visual",
    description: "Replique o padrão de blocos para consertar a nave.",
    test: "WISC-V (Cubos)",
    color: "#FBBF24",
    emoji: "🧱",
    category: "Inteligência & cognição",
    bg: "https://static.prod-images.emergentagent.com/jobs/1b50bf18-ab86-47e3-8c7b-2dc2af0ac3d3/images/7f07e2e8119f844d9003c3f1e126c25cfad2edada57e3edcae23640204ca7d88.png",
    route: "/play/game/builders-workshop",
  },
  {
    id: "silence_temple",
    name: "Templo do Silêncio",
    short: "Categorização não verbal",
    description: "Encontre o objeto diferente. Sem usar palavras!",
    test: "SON-R — inteligência não verbal",
    color: "#8B5CF6",
    emoji: "🗿",
    category: "Inteligência & cognição",
    bg: HUB_HERO,
    bgGradient: "linear-gradient(135deg, #5B21B6 0%, #1E1B4B 100%)",
    route: "/play/game/silence-temple",
  },
  {
    id: "pattern_labyrinth",
    name: "Labirinto dos Padrões",
    short: "Raciocínio lógico",
    description: "Escolha a peça que completa o padrão da porta.",
    test: "Matrizes de Raven",
    color: "#10B981",
    emoji: "🧩",
    category: "Inteligência & cognição",
    bg: HUB_HERO,
    bgGradient: "linear-gradient(135deg, #064E3B 0%, #022C22 100%)",
    route: "/play/game/pattern-labyrinth",
  },

  // === TEA / Social ===
  {
    id: "npc_village",
    name: "Vila dos NPCs",
    short: "Interação social",
    description: "Conheça os moradores e ajude cada um do seu jeito.",
    test: "Observação social (estilo ADOS-2)",
    color: "#F97316",
    emoji: "🏘️",
    category: "Interação social",
    bg: HUB_HERO,
    bgGradient: "linear-gradient(135deg, #C2410C 0%, #7C2D12 100%)",
    route: "/play/game/npc-village",
  },

  // === Auto-relato ===
  {
    id: "magic_thermometer",
    name: "Termômetro Mágico",
    short: "Como você se sente?",
    description: "Conte para o mascote como você se sente em cada situação.",
    test: "MASC-2 / CDI — auto-relato",
    color: "#EF4444",
    emoji: "🌡️",
    category: "Como você se sente",
    bg: HUB_HERO,
    bgGradient: "linear-gradient(135deg, #DC2626 0%, #7F1D1D 100%)",
    route: "/play/game/magic-thermometer",
  },

  // === Linguagem / Escola ===
  {
    id: "echo_cave",
    name: "Caverna dos Ecos",
    short: "Vocabulário",
    description: "Encontre a figura certa para cada palavra que aparecer.",
    test: "Linguagem (estilo ABFW)",
    color: "#0EA5E9",
    emoji: "🦇",
    category: "Linguagem & escola",
    bg: HUB_HERO,
    bgGradient: "linear-gradient(135deg, #0C4A6E 0%, #082F49 100%)",
    route: "/play/game/echo-cave",
  },
  {
    id: "animal_choir",
    name: "Coral dos Animais",
    short: "Sons & rimas",
    description: "Junte os bichinhos cujos nomes começam com o mesmo som.",
    test: "Consciência fonológica",
    color: "#84CC16",
    emoji: "🎵",
    category: "Linguagem & escola",
    bg: HUB_HERO,
    bgGradient: "linear-gradient(135deg, #65A30D 0%, #365314 100%)",
    route: "/play/game/animal-choir",
  },
  {
    id: "secret_library",
    name: "Biblioteca Secreta",
    short: "Leitura & cálculo",
    description: "Resolva os feitiços lendo placas e fazendo contas.",
    test: "TDE-II — desempenho escolar",
    color: "#A855F7",
    emoji: "📚",
    category: "Linguagem & escola",
    bg: HUB_HERO,
    bgGradient: "linear-gradient(135deg, #6B21A8 0%, #3B0764 100%)",
    route: "/play/game/secret-library",
  },

  // === Questionários para responsáveis ===
  {
    id: "guardian_portal",
    name: "Portal dos Guardiões",
    short: "Para o responsável",
    description: "Conte um pouco sobre o desenvolvimento da criança.",
    test: "ADI-R / CARS — entrevista",
    color: "#0F172A",
    emoji: "🛡️",
    category: "Para o responsável",
    bg: HUB_HERO,
    bgGradient: "linear-gradient(135deg, #1E293B 0%, #0F172A 100%)",
    route: "/play/game/guardian-portal",
    forAdult: true,
  },
  {
    id: "ship_log",
    name: "Diário de Bordo",
    short: "Para o responsável",
    description: "Como foi a semana? Avaliação periódica de comportamento.",
    test: "CBCL / BASC-3 — comportamento",
    color: "#475569",
    emoji: "📓",
    category: "Para o responsável",
    bg: HUB_HERO,
    bgGradient: "linear-gradient(135deg, #334155 0%, #0F172A 100%)",
    route: "/play/game/ship-log",
    forAdult: true,
  },
];

export const GAME_BY_ID = Object.fromEntries(GAMES.map((g) => [g.id, g]));

export const HUB_BG = HUB_HERO;

export const MASCOT =
  "https://static.prod-images.emergentagent.com/jobs/1b50bf18-ab86-47e3-8c7b-2dc2af0ac3d3/images/919c6b4c611057c7ab8c8f6f8d375dd86a515d26c67a5f04e49fc7f2898f4c49.png";

// Order of categories for the hub
export const CATEGORIES = [
  "Atenção & funções executivas",
  "Inteligência & cognição",
  "Interação social",
  "Como você se sente",
  "Linguagem & escola",
  "Para o responsável",
];
